import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { SvelteComponent, init, safe_not_equal, empty, insert, noop, detach, HtmlTag } from '../../node_modules/svelte/internal/index.mjs.js';

function create_if_block(ctx) {
  let html_tag;
  let html_anchor;
  return {
    c() {
      html_tag = new HtmlTag(false);
      html_anchor = empty();
      html_tag.a = html_anchor;
    },
    m(target, anchor) {
      html_tag.m( /*configScript*/ctx[1], target, anchor);
      insert(target, html_anchor, anchor);
    },
    p(ctx, dirty) {
      if (dirty & /*configScript*/2) html_tag.p( /*configScript*/ctx[1]);
    },
    d(detaching) {
      if (detaching) detach(html_anchor);
      if (detaching) html_tag.d();
    }
  };
}
function create_fragment(ctx) {
  let if_block_anchor;
  let if_block = /*isT3Env*/ctx[0] && create_if_block(ctx);
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx, _ref) {
      let [dirty] = _ref;
      if ( /*isT3Env*/ctx[0]) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block(ctx);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let {
    isT3Env = true
  } = $$props;
  let {
    config = {}
  } = $$props;

  // Svelte treats non-top-level <script> tags as plain text
  // and doesn't interpolate JS variables there,
  // so we're using template strings as a workaround
  let configScript;
  $$self.$$set = function ($$props) {
    if ('isT3Env' in $$props) $$invalidate(0, isT3Env = $$props.isT3Env);
    if ('config' in $$props) $$invalidate(2, config = $$props.config);
  };
  $$self.$$.update = function () {
    if ($$self.$$.dirty & /*config*/4) {
      // eslint-disable-next-line no-useless-concat
      $$invalidate(1, configScript = "<script type=\"text/x-config\">".concat(JSON.stringify(config), "</") + 'script>');
    }
  };
  return [isT3Env, configScript, config];
}
let T3Config = /*#__PURE__*/function (_SvelteComponent) {
  function T3Config(options) {
    var _this;
    _classCallCheck(this, T3Config);
    _this = _callSuper(this, T3Config);
    init(_this, options, instance, create_fragment, safe_not_equal, {
      isT3Env: 0,
      config: 2
    });
    return _this;
  }
  _inherits(T3Config, _SvelteComponent);
  return _createClass(T3Config);
}(SvelteComponent);

export { T3Config as default };
